// src/data/publicationsData.js

export const topics = [
  'All',
  'Biofeedback',
  'Rehabilitation',
  'Clinical AI',
  'Interventions',
];


export const HCI= [
  'All',
  'VR/MR',
  'Tangible',
  'Ambient',
  'Wearable',
  'Visualization',
  'Haptic',
  'Applied AI'
];



export const publicationsData = [


     {
    id: 32,
    date: '2026',
    title: 'WarmStone: Ceramic Making as a Participatory Design Approach to Personalized Haptic Comfort',
    authors: 'Yu, Bin and Zhou, Zixun and Chen, Jie and Wang, Bo and Allouch, Somaya Ben',
    summary: 'Digital stress-relief tools can backfire, adding screen fatigue and tech-driven anxiety. This study explores a low-tech alternative: ceramics. Twenty stressed participants joined workshops to craft WarmStones, personalized handheld clay objects for touch-based comfort and self-soothing. After daily use for four weeks, interviews and object analysis revealed how shape, texture, and touch patterns help people manage stress. The findings show how everyday ceramic objects can become tactile comfort tools, offering design ideas for personalized objects that support calm in daily life.',
    pdf: '', // <-- public folder path
    doi: 'https://doi.org/10.1145/3803784.3816829',
    thumbnail: 'thumb27',
    topic: 'Interventions',
    HCI: 'Tangible',
    journal: 'Proceedings of the 2026 Conference on Creativity and Cognition (C&C)',
    honorableMention: false,
    bestPaper: false,
     },


    {
    id: 31,
    date: '2026',
    title: 'MindFeed: Leveraging Social Media for AI-assisted Reflective Journaling',
    authors: 'Yu, Bin and Nguyen, L{\^a}n and Lu, Tianqin and Ben Allouch, Somaya',
    summary: 'Reflective journaling can boost self-insight and well-being, but generic prompts often feel unengaging over time. MindFeed is an AI-assisted journaling tool that creates personalized prompts from a user\'s own social media stories. It analyzes photos and captions from Instagram or Snapchat, reads emotional tone, and turns them into meaningful journaling questions. In a study with 20 people, MindFeed matched traditional journaling in engagement, though its ability to spark deep insight varied. Prompt clarity, openness, and authenticity mattered most to users.',
    pdf: '', // <-- public folder path
    doi: 'https://doi.org/10.1145/3786995.3787053',
    thumbnail: 'thumb27',
    topic: 'Interventions',
    HCI: 'Applied AI',
    journal: 'Proceedings of the 2025 International Conference on Human-Engaged Computing',
    honorableMention: false,
    bestPaper: false,
     },

    {
    id: 30,
    date: '2026',
    title: 'CoBreath: Designing a VR-Based Dyadic Biofeedback System to Support Breathing Exercise for Breast Cancer Survivors',
    authors: 'Wang, Qi and Yan, Yifan and Fang, Shiwen and An, Qingfan and Luo, Xiujia and Jia, Jie and Yu, Bin',
    summary: 'Breast cancer survivors often face chronic stress and anxiety. Peer support and biofeedback can each help, but few tools combine them. Building on interviews with clinicians and survivors, we created Cobreath, a VR system where two people practice calming breathing together while seeing real-time heart rate feedback in a shared virtual environment. Studies with clinicians and 32 survivors showed this shared, dyadic mode worked better and felt more supportive than practicing alone, offering design insights for shared VR relaxation tools.',
    pdf: '', // <-- public folder path
    doi: 'https://doi.org/10.1145/3772318.3791096',
    thumbnail: 'thumb27',
    topic: 'Biofeedback',
    HCI: 'VR/MR',
    journal: 'Proceedings of the 2026 CHI Conference on Human Factors in Computing Systems (CHI)',
    honorableMention: true,
    bestPaper: false,
     },


    {
    id: 29,
    date: '2026',
    title: 'ASafePlace: User-Led Personalization of VR Relaxation via an Art Therapy Activity',
    authors: 'Zhang, Chuyang and Yu, Bin and Wang, Yuchao and Yuan, Mansi and Wang, Wanqi and Je, Seungwoo and An, Pengcheng',
    summary: 'Standard biofeedback tools often feel generic and impersonal. ASafePlace changes that with an art-therapy-inspired exercise called The Safe Place, letting people sketch a personal sanctuary from memory. This drawing becomes a custom 360-degree virtual environment with guided audio for relaxation. In a study with 52 participants, ASafePlace reduced anxiety, boosted feelings of presence, and produced strong physiological relaxation, shown through heart rate and breathing changes. Participants felt more familiar and present thanks to meaningful scenery built from their own memories.',
    pdf: '', // <-- public folder path
    doi: 'https://doi.org/10.1145/3772318.3790571',
    thumbnail: 'thumb27',
    topic: 'Biofeedback',
    HCI: 'VR/MR',
    journal: 'Proceedings of the 2026 CHI Conference on Human Factors in Computing Systems (CHI)',
    honorableMention: false,
    bestPaper: false,
    },

    {
    id: 28,
    date: '2017',
    title: 'Evaluation of Normal Swallowing Functions Using Dynamic High-Density Surface Electromyography Maps',
    authors: 'Zhu, Mingxing and Yu, Bin and Yang, Wanzhang and Jiang, Yanbing and Lu, Lin and Huang, Zhen and Chen, Shixiong and Li, Guanglin',
    summary: 'This study proposed a novel high-density surface electromyography (HD sEMG) technique to evaluate normal swallowing functions. Ninety-six electrodes recorded myoelectric signals from 12 healthy subjects performing various swallowing tasks. HD sEMG energy maps visualized spatial and temporal muscle activities, revealing how swallowing is influenced by bolus volume, viscosity, and head posture. Results showed muscle activity patterns shift with head movement and swallowing effort varies with bolus properties. The method offers a comprehensive, objective approach for assessing normal swallowing and may aid in dysphagia screening.',
    pdf: '', // <-- public folder path
    doi: 'https://doi.org/10.1186/s12938-017-0424-x',
    thumbnail: 'thumb27',
    topic: 'Rehabilitation',
    HCI: 'Visualization',
    journal: 'Biomedical engineering online （Biomed. Eng. Online）',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 27,
    date: '2025',
    title: 'GlowGrow: Designing an Ambient Biofeedback System for Pregnancy Stress Management',
    authors: 'Xue, Mengru; Yu, Bin; Wu, Jiang; Sun, Xu; Fang, Peidi; Yao, Cheng; Ying, Fangtian; Luo, Shijian; Zhang, Sheng',
    summary: 'Pregnancy can induce stress, increasing the risk of postpartum depression with negative effects on mothers and families. Traditional biofeedback for anxiety is effective but often intrusive and clinician-dependent. This study developed GlowGrow, an immersive biofeedback system combining wearable sensors, music, and ambient light, enabling pregnant women to practice slow-paced resonant breathing for relaxation. Deployed in a hospital ante-natal clinic and evaluated by 24 participants, GlowGrow effectively guided deep breathing, reduced physiological stress, and offered a positive user experience, demonstrating its potential as a practical stress-management intervention.',
    pdf: '/publications/glowgrow.pdf', // <-- public folder path
    doi: 'https://doi.org/10.1371/journal.pone.0320866',
    thumbnail: 'thumb27',
    topic: 'Biofeedback',
    HCI: 'Ambient',
    journal: 'PLoS One',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 26,
    date: '2025',
    title: 'Computer-Aided Decision Support and 3D Models in Pancreatic Cancer Surgery: A Pilot Study',
    authors: 'Rasenberg, Diederik WM; Ramaekers, Mark; Jacobs, Igor; Pluyter, Jon R; Geurts, Luc JF; Yu, Bin; van der Ven, John CP; Nederend, Joost; de Hingh, Ignace HJT; Bonsing, Bert A; others',
    summary: 'Preoperative planning for pancreatic head cancer is challenging and requires specialized expertise. This pilot study evaluated how interactive three-dimensional (3D) patient models and computer-aided detection (CAD) visualizations support tumor resectability assessment. Fourteen hepatopancreatobiliary experts reviewed resectable and borderline cases using CT, 3D models, and CAD. CAD improved perceived assessment of tumor–vessel contact, while 3D visualizations enhanced confidence in predicting vascular resection. The study highlights that well-designed visual and interactive tools can enhance understanding, decision-making, and planning in pancreatic cancer management.',
    pdf: '/publications/jcmCAD.pdf',
    doi: 'https://doi.org/10.3390/jcm14051567',
    thumbnail: 'thumb26',
    topic: 'Clinical AI',
    HCI: 'Visualization',
    journal: 'Journal of Clinical Medicine',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 25,
    date: '2025',
    title: 'EmoVis: Exploring Data-Enabled Analogue Journaling to Promote Self-Reflection for Mental Wellness Among College Students',
    authors: 'Ren, Xipei; Zhang, Xiaoyu; Zou, Renyao; Yan, Ran; Yu, Bin',
    summary: 'College students face many stressors, making them vulnerable to mental health issues. This study presents EmoVis, a data-enabled analogue journaling (DEAJ) tool that integrates visualized daily physiological data and event tags into printed templates to support doodling and structured writing. A six-day field study with 32 students showed that EmoVis enhanced engagement and self-reflection, with the doodling canvas fostering mindfulness and creativity, while the writing template promoted efficient reflection. The findings highlight the value of interactive visualizations in supporting everyday stress management.',
    pdf: '/publications/EmoVis.pdf',
    doi: 'https://doi.org/10.1080/0144929X.2024.2349182',
    thumbnail: 'thumb25',
    topic: 'Interventions',
    HCI: 'Visualization',
    journal: 'Behaviour & Information Technology',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 24,
    date: '2026',
    title: 'ZooWear: Animal-Inspired Head-Mounted Haptic Interfaces to Augment the Zoo Experience',
    authors: 'Chen, Pingting; Yu, Bin; Sun, Xiaoqing; Xia, Jiangnan; Liu, Xinyu; Ren, Xipei',
    summary: 'Explores animal-inspired head-mounted haptic interfaces for enhancing zoo experiZoos play a key role in public education, but traditional visits often lack interactive engagement. This study introduces ZooWear, a head-mounted wearable with cartoon-style animal ears providing haptic feedback that simulates animal reactions. Lab and real-world experiments showed ZooWear enhanced perspective-taking, nature connectedness, and emotional engagement. By integrating embodied sensory feedback, narrative-driven interaction, and playful visualization, ZooWear demonstrates how interactive wearable design can enrich zoo experiences, foster meaningful human-animal connections, and support learning through immersive, embodied interactions.ences.',
    pdf: '/publications/ZooWear.pdf',
    doi: 'https://doi.org/10.1080/10447318.2025.2583471',
    thumbnail: 'thumb24',
    topic: 'All',
    HCI: 'Tangible',
    journal: 'International Journal of Human-Computer Interaction (IJCHI)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 23,
    date: '2025',
    title: 'MindFlow: Breathing-Integrated Progressive Muscle Relaxation with a Full-Body Self-Avatar in Virtual Reality',
    authors: 'Yang, Hangcheng; Chan, Yuan-An; Yu, Bin; Hung, Yi-Ping; Markopoulos, Panos; Liang, Rong-Hao',
    summary: 'breathing guidance into PMR in VR is challenging due to presence and effectiveness concerns. This paper introduces MindFlow, a VR system combining breathing biofeedback with a full-body self-avatar and mindfulness-based principles to deliver breathing-integrated PMR. A 24-participant study shows that MindFlow effectively enhances relaxation and reduces anxiety in novice users. Findings provide insights for designing embodied mindfulness systems and guide future research on mindfulness support in virtual and mixed reality.',
    pdf: '',
    doi: 'https://doi.org/10.1145/3715336.373571',
    thumbnail: 'thumb23',
    topic: 'Biofeedback',
    HCI: 'VR/MR',
    journal: 'Proceedings of the 2025 ACM Designing Interactive Systems Conference (DIS)',
    honorableMention: false,  
    bestPaper: false
  },
  {
    id: 22,
    date: '2024',
    title: 'Designing Smart Legging for Posture Monitoring Based on Textile Sensing Networks',
    authors: 'Wang, Qi; Cui, Fang; Zhang, Runhua; Chen, Leheng; Yuan, Jialin; Sun, Xiaohua; Yu, Bin',
    summary: 'Running is popular, but poor posture over time can cause knee injuries. This study developed a smart legging with a resistive textile sensor network to monitor lower body motion. Sensor units were tested for linearity and robustness, optimal placement was determined, and a network was designed. Using data from six participants and an LSTM model, the system identified three improper running postures and normal posture with 99.1% accuracy. Results show its potential to help users prevent knee injuries through continuous monitoring and feedback.',
    pdf: '',
    doi: 'https://doi.org/10.1080/10447318.2023.2261704',
    thumbnail: 'thumb22',
    topic: 'Rehabilitation',
    HCI: 'Wearable',
    journal: 'International Journal of Human-Computer Interaction (IJCHI)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 21,
    date: '2024',
    title: 'MRehab: A Mixed Reality Rehabilitation System Supporting Integrated Speech and Hand Training',
    authors: 'Wang, Qi; Luo, Can; Yang, Shuai; Xu, Shuo; Yang, Yibo; Jia, Jie; Yu, Bin',
    summary: 'Integrated speech and hand-motor training aids post-stroke rehabilitation, but few interactive systems exist. This study leveraged Mixed Reality (MR) to provide immersive scenarios with physical tools for engaging, multi-modal training. Using a user-centered design, seven therapists were interviewed to inform requirements, leading to the development of MRehab, which enables patients to regain speech and hand skills through daily-life MR activities. A preliminary test with 12 patients and 5 therapists confirmed feasibility, high motivation, engagement, and positive user experiences, highlighting MR’s potential in integrated rehabilitation.',
    pdf: '/publications/2024mrehab.pdf',
    doi: 'https://doi.org/10.1145/3678532',
    thumbnail: 'thumb21',
    topic: 'Rehabilitation',
    HCI: 'VR/MR',
    journal: 'Proceedings of the ACM on Interactive, Mobile, Wearable and Ubiquitous Technologies (IMWUT)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 20,
    date: '2024',
    title: "I'm not upset--I get it: Effects of Co-workers' Stress Cues on Help-seekers' Social Diction and Empathy in Telecommuting",
    authors: 'Zhang, Ning; Yu, Bin; Hu, Jun; Li, Min; An, Pengcheng',
    summary: 'Help-seeking messages are often rejected in work environments. This study examined how signaling co-workers’ stress status affects the social diction and empathy of help-seekers. Thirty-six participants used a messaging app with TacStatus, a vibrotactile device indicating co-workers’ emotional states (no-cue, relaxed, normal, stressful). Analysis showed stress cues influenced help-seekers’ responses: relaxed cues led to disappointment after rejection, while stressful cues elicited more positive emotions. Findings reveal how stress signals shape professional messaging and inform the design of socio-emotional cues in collaborative systems.',
    pdf: '/publications/stress_cues_telecommuting.pdf',
    doi: 'https://doi.org/10.1016/j.ijhcs.2024.103218',
    thumbnail: 'thumb20',
    topic: 'Interventions',
    HCI: 'Haptic',
    journal: 'International Journal of Human-Computer Studies (IJHCS)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 19,
    date: '2022',
    title: 'Understanding How Group Workers Reflect on Organizational Stress With a Shared, Anonymous Heart Rate Variability Data Visualization',
    authors: 'Xue, Mengru; Liang, Rong-Hao; Hu, Jun; Yu, Bin; Feijs, Loe',
    summary: 'Investigates how teams reflect on organizational stress using shared HRV data visualThis paper presents a case study on using a shared, anonymous heart rate variability (HRV) visualization system to increase awareness of work-related stress among office workers. Over one week, 24 workers in six workplaces wore sensors, and HRV data were displayed anonymously in four-person groups. Despite noisy data from field conditions, participants increasingly trusted the system and used it to assess stress. Findings highlight individual and social reflection on stress and offer design insights for long-term shared physiological data visualization in group stress management.izations.',
    pdf: '/publications/social_HVR_vis.pdf',
    doi: 'https://doi.org/10.1145/3491101.3503576',
    thumbnail: 'thumb19',
    topic: 'Biofeedback',
    HCI: 'Visualization',
    journal: 'CHI Conference on Human Factors in Computing Systems (Extended Abstracts)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 18,
    date: '2022',
    title: 'Trust in Clinical AI: Expanding the Unit of Analysis',
    authors: 'Browne, Jacob T; Bakker, Saskia; Yu, Bin; Lloyd, Peter; Ben Allouch, Somaya',
    summary: 'AI is expanding across clinical applications, yet adoption remains limited due to trust challenges among clinicians. This paper examines trust beyond direct AI interaction, identifying key stages in development, deployment, and monitoring that shape confidence. It argues trust calibration must extend beyond explainability to the entire implementation process, supported by practitioner case studies..',
    pdf: '/publications/trust_AI.pdf',
    doi: 'https://doi.org/10.3233/FAIA220192',
    thumbnail: 'thumb18',
    topic: 'Clinical AI',
    HCI: 'All',
    journal: 'International Conference on Hybrid Human-Artificial Intelligence (HHAI)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 17,
    date: '2021',
    title: 'ViBreathe: Heart Rate Variability Enhanced Respiration Training for Workaday Stress Management via an Eyes-Free Tangible Interface',
    authors: 'Yu, Bin; An, Pengcheng; Hendriks, Sjoerd; Zhang, Ning; Feijs, Loe; Li, Min; Hu, Jun',
    summary: 'Slow breathing apps help knowledge workers manage stress but often use rigid, non-interactive pacing that can cause fatigue and reduce motivation. This study explores heart rate variability (HRV)–mediated guidance through responsive and adaptive modes implemented in a soft haptic interface, ViBreathe. A user test (N=24) and one-week field deployment (N=4) found HRV-enhanced guidance reduced tiredness while improving engagement and comfort. Results highlight ViBreathe’s potential to integrate breathing practices into daily work and provide design insights for future systems.',
    pdf: '',
    doi: 'https://doi.org/10.1080/10447318.2021.1898827',
    thumbnail: 'thumb17',
    topic: 'Biofeedback',
    HCI: 'Haptic',
    journal: 'International Journal of Human-Computer Interaction (IJCHI)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 16,
    date: '2020',
    title: 'Biofeedback Painting: Let the Heart Lead the Brush',
    authors: 'Yu, Bin; Arents, Rogier',
    summary: 'This paper presents an art-oriented project that visualizes heart rate variability using a pen plotter. The biofeedback approach generates drawings driven by participants’ heart activity, reflecting their mental, physical, and emotional states. By merging biofeedback techniques with visual art, the project introduces a novel creative process.',
    pdf: '',
    doi: 'https://doi.org/10.1162/leon_a_01772',
    thumbnail: 'thumb16',
    topic: 'Biofeedback',
    HCI: 'Visualization',
    journal: 'Leonardo',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 15,
    date: '2019',
    title: 'AffectiveWall: Designing Collective Stress-Related Physiological Data Visualization for Reflection',
    authors: 'Xue, Mengru; Liang, Rong-Hao; Yu, Bin; Funk, Mathias; Hu, Jun; Feijs, Loe',
    summary: 'Excessive workplace stress harms individual health and collaboration, yet subjective reflection can lead to misinterpretation. This paper explores stress reflection using objective physiological data displayed anonymously through a shared visualization of heart rate variability. A minimalist proof-of-concept system was deployed during group collaboration to examine the design space. User study results showed increased awareness and improved understanding of personal and organizational stress. Findings emphasize the value of objective physiological data in supporting effective reflection and organizational stress management.',
    pdf: '/publications/AffectiveWall.pdf',
    doi: 'https://doi.org/10.1109/ACCESS.2019.2940866',
    thumbnail: 'thumb15',
    topic: 'Biofeedback',
    HCI: 'Visualization',
    journal: 'IEEE Access',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 14,
    date: '2019',
    title: 'Automatic Detection of Atrial Fibrillation from Ballistocardiogram (BCG) Using Wavelet Features and Machine Learning',
    authors: 'Yu, Bin; Zhang, Biyong; Xu, Lisheng; Fang, Peng; Hu, Jun',
    summary: 'This paper introduces an unobtrusive method for detecting atrial fibrillation (AF) during sleep using single-channel ballistocardiogram (BCG) recordings. A sensor embedded in a mattress remotely collected data from 12 patients overnight, dividing recordings into 30-second epochs. Features extracted via stationary wavelet transform trained multiple classifiers, all achieving over 91.5% accuracy. The optimized Bagged Trees model reached 0.944 accuracy, 0.970 sensitivity, and 0.891 specificity, highlighting the system’s potential as an effective home-based screening tool for AF detection.',
    pdf: '/publications/BCGAF.pdf',
    doi: 'https://doi.org/10.1109/EMBC.2019.8857059',
    thumbnail: 'thumb14',
    topic: 'Clinical AI',
    HCI: 'All',
    journal: '2019 41st Annual International Conference of the IEEE Engineering in Medicine and Biology Society (EMBC)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 13,
    date: '2019',
    title: 'An Unobtrusive Stress Recognition System for the Smart Office',
    authors: 'Yu, Bin; Zhang, Biyong; An, Pengcheng; Xu, Lisheng; Xue, Mengru; Hu, Jun',
    summary: 'This paper proposes a novel method to monitor office workers’ behaviors and heart rate variability (HRV) using an EMFi sensor integrated into a chair. Machine learning classified activities such as moving, typing, talking, and browsing with up to 91% accuracy. Data identified as browsing were further processed to calculate HRV, achieving an average error of 5.77 ms. By combining behavioral and physiological data, the approach offers a comprehensive view of work-related stress and supports unobtrusive early stress detection in smart office environments.',
    pdf: '/publications/SmartOfficeSeat.pdf',
    doi: 'https://doi.org/10.1109/EMBC.2019.8856597',
    thumbnail: 'thumb13',
    topic: 'Biofeedback',
    HCI: 'Ambient',
    journal: '2019 41st Annual International Conference of the IEEE Engineering in Medicine and Biology Society (EMBC)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 12,
    date: '2018',
    title: 'Biofeedback for Everyday Stress Management: A Systematic Review',
    authors: 'Yu, Bin; Funk, Mathias; Hu, Jun; Wang, Qi; Feijs, Loe',
    summary: 'This systematic review examines biofeedback systems for stress management amid rising stress-related health issues and advances in sensing technologies. Analyzing 46 studies published between 1990 and 2016, it identifies HRV, multimodal biofeedback, respiration, heart rate, and GSR as common techniques, typically delivered through screen-based displays and evaluated via physiological and psychological measures. The review highlights challenges such as improving user interpretation, enabling ubiquitous sensing, and conducting field evaluations, while suggesting emerging HCI technologies and interaction designs to enhance usability, comfort, and everyday engagement.',
    pdf: '/publications/biofeedbackreview.pdf',
    doi: 'https://doi.org/10.3389/fict.2018.00023',
    thumbnail: 'thumb12',
    topic: 'Biofeedback',
    HCI: 'All',
    journal: 'Frontiers in ICT',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 11,
    date: '2018',
    title: 'RESonance: Lightweight, Room-Scale Audio-Visual Biofeedback for Immersive Relaxation Training',
    authors: 'Yu, Bin; Hu, Jun; Funk, Mathias; Liang, Rong-Hao; Xue, Mengru; Feijs, Loe',
    summary: 'Biofeedback systems promote awareness of physiological states to support self-regulation and behavior change. While single-modal displays are clear but less engaging, multimodal systems enhance engagement yet are harder to deploy. This paper introduces RESonance, a lightweight immersive audio-visual biofeedback system using ambient light and nature soundscapes to convey breathing and heart rate variability. A 24-participant study found the system effectively supported breathing regulation while delivering engaging, immersive experiences, demonstrating a practical balance between user engagement and deployment simplicity for relaxation training.',
    pdf: '',
    doi: 'https://doi.org/10.1109/ACCESS.2018.2853406',
    thumbnail: 'thumb11',
    topic: 'Biofeedback',
    HCI: 'Ambient',
    journal: 'IEEE Access',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 10,
    date: '2018',
    title: 'Unwind: A Musical Biofeedback for Relaxation Assistance',
    authors: 'Yu, Bin; Funk, Mathias; Hu, Jun; Feijs, Loe',
    summary: 'Presents a musical biofeedback system designedUnWind is a musical biofeedback interface that blends responsive nature sounds with sedative, New-Age-style music to support relaxation. The nature sounds reflect users’ physiological data, while the music promotes calmness and positive emotions. A 2×2 factorial study with forty young adults compared four conditions following a stress task. Results showed a significant interaction between music and biofeedback, improving heart rate variability. Combining music and nature sounds also reduced arousal and self-reported anxiety, highlighting the potential of musical interfaces for effective biofeedback-based relaxation. to assist relaxation.',
    pdf: '/publications/Unwind.pdf',
    doi: 'https://doi.org/10.1080/0144929X.2018.1484515',
    thumbnail: 'thumb10',
    topic: 'Biofeedback',
    HCI: 'Ambient',
    journal: 'Behaviour & Information Technology',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 9,
    date: '2018',
    title: 'DeLight: Biofeedback Through Ambient Light for Stress Intervention and Relaxation Assistance',
    authors: 'Yu, Bin; Hu, Jun; Funk, Mathias; Feijs, Loe',
    summary: 'Ambient light-based biofeedback system to sDeLight is a biofeedback-driven lighting system designed to communicate stress levels and support relaxation training through ambient light. Integrated with heart rate variability data, it operates in two modes: stress intervention and relaxation assistance. Two user studies showed that adaptive lighting increased stress awareness, encouraged behaviors like deep breathing, and supported physiological regulation as effectively as graphic biofeedback. The immersive environment enhanced both subjective relaxation and arousal reduction, suggesting biofeedback lighting can act as persuasive technology for health self-management while creating a comfortable, informative atmosphere.upport stress intervention and relaxation.',
    pdf: '/publications/Delight.pdf',
    doi: 'https://doi.org/10.1007/s00779-018-1141-6',
    thumbnail: 'thumb9',
    topic: 'Biofeedback',
    HCI: 'Ambient',
    journal: 'Personal and Ubiquitous Computing',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 8,
    date: '2018',
    title: 'BioFidget: Biofeedback for Respiration Training Using an Augmented Fidget Spinner',
    authors: 'Liang, Rong-Hao; Yu, Bin; Xue, Mengru; Hu, Jun; Feijs, Loe MG',
    summary: 'Implements a fidget-spinner devThis paper introduces BioFidget, a biofeedback system that transforms a fidget spinner into a tool for respiration training. It integrates a nonintrusive heart rate variability sensor, an electromechanical respiration sensor, and an information display, enabling tangible and embodied interactions without additional wearable sensors. A user study with 32 participants demonstrated that BioFidget effectively supports respiration training, reduces stress, and maintains valid physiological sensing while keeping users engaged, highlighting its potential as a practical, accessible, and interactive biofeedback device.ice augmented with biofeedback for respiration training.',
    pdf: '/publications/BioFidget.pdf',
    doi: 'https://doi.org/10.1145/3173574.31741',
    thumbnail: 'thumb8',
    topic: 'Biofeedback',
    HCI: 'Tangible',
    journal: 'Proceedings of the 2018 CHI Conference on Human Factors in Computing Systems (CHI)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 7,
    date: '2019',
    title: 'HealthSit: Designing Posture-Based Interaction to Promote Exercise During Fitness Breaks',
    authors: 'Ren, Xipei; Yu, Bin; Lu, Yuan; Chen, Yu; Pu, Pearl',
    summary: 'Designs posture-based interactions to encourage exercise duriThis study introduces HealthSit, a posture-based interactive system designed to encourage office workers to perform short lower-back stretches during work breaks, addressing risks from prolonged sedentary behavior. A within-subject study with 30 participants compared interaction-aided, guided, and self-directed modes. Results showed that the interaction-aided mode significantly improved exercise quality, motivation, and emotional well-being. HealthSit demonstrates the potential of interactive workplace technologies to support effective fitness breaks, offering insights and design implications for enhancing user experience and promoting psychological and physical health.g office fitness breaks.',
    pdf: '/publications/HealthSit.pdf',
    doi: 'https://doi.org/10.1080/10447318.2018.1506641',
    thumbnail: 'thumb7',
    topic: 'Interventions',
    HCI: 'Ambient',
    journal: 'International Journal of Human--Computer Interaction (IJCHI)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 6,
    date: '2018',
    title: 'Exploring Cooperative Fitness Tracking to Encourage Physical Activity Among Office Workers',
    authors: 'Ren, Xipei; Yu, Bin; Lu, Yuan; Brombacher, Aarnout',
    summary: 'Investigates cThis paper reports a field study on Peer-based Cooperative Fitness Tracking (PCFT) to promote workplace physical activity. Ten co-worker dyads, divided into co-located and distributed groups, tracked fitness over three weeks: baseline, intervention, and post-intervention. Results showed that co-located participants significantly increased activity during the PCFT intervention. Qualitative findings suggest PCFT enhances awareness of activity, encourages knowledge exchange, and supports integrating fitness breaks into work routines. The study offers design insights for developing PCFT applications to boost workplace vitality.ooperative fitness tracking designs to motivate office workers to exercise.',
    pdf: '/publications/CooperativeFitnessTracking.pdf',
    doi: 'https://doi.org/10.1145/3274415',
    thumbnail: 'thumb6',
    topic: 'Interventions',
    HCI: 'Tangible',
    journal: 'Proceedings of the ACM on Human-Computer Interaction (CSCW)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 5,
    date: '2017',
    title: 'StressTree: A Metaphorical Visualization for Biofeedback-Assisted Stress Management',
    authors: 'Yu, Bin; Funk, Mathias; Hu, Jun; Feijs, Loe',
    summary: 'Uses a tree metaphThis paper introduces StressTree, a heart rate variability (HRV) biofeedback system designed for stress management and relaxation training. StressTree visualizes HRV data metaphorically, showing tree growth patterns that reflect stress or relaxation states. The system includes heartbeat data acquisition, analysis, and visualization units. Evaluation interviews indicated that StressTree provides explicit and engaging feedback, motivating users to regulate their breathing. Participants reported that the evocative visualization encourages healthier behaviors, making stress management more meaningful and enjoyable through an interactive, visually compelling biofeedback experience.or to visualize stress levels for biofeedback-assisted stress management.',
    pdf: '/publications/StressTree.pdf',
    doi: 'https://doi.org/10.1145/3064663.3064729',
    thumbnail: 'thumb5',
    topic: 'Biofeedback',
    HCI: 'Visualization',
    journal: 'Proceedings of the 2017 Conference on Designing Interactive Systems (DIS)',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 4,
    date: '2017',
    title: 'A Model of Nature Soundscape for Calm Information Display',
    authors: 'Yu, Bin; Hu, Jun; Funk, Mathias; Feijs, Loe',
    summary: 'Proposes a model of nature This study develops a nature soundscape model to support calm technology and ambient information displays. A three-layer structure with seven acoustic parameters was used to create soundscape samples, each set at three levels. Twenty participants evaluated 21 samples across seven perceptual attributes. Based on the results, a perceptual model was proposed linking acoustic parameters to perceived qualities. The model provides designers with a practical tool for incorporating nature sounds into auditory displays, enhancing calm, peripheral, and ambient interactions in technology design.soundscapes for calm information display in interactive systems.',
    pdf: '/publications/Soundscape_model.pdf',
    doi: 'https://doi.org/10.1093/iwc/iwx007',
    thumbnail: 'thumb4',
    topic: 'Biofeedback',
    HCI: 'Ambient',
    journal: 'Interacting with Computers',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 3,
    date: '2017',
    title: 'Interactive Wearable Systems for Upper Body Rehabilitation: A Systematic Review',
    authors: 'Wang, Qi; Markopoulos, Panos; Yu, Bin; Chen, Wei; Timmermans, Annick',
    summary: 'Reviews inteThis paper reviews interactive wearable systems for upper body rehabilitation, focusing on sensing technology, feedback, wearability, and clinical evidence. A systematic search identified 45 studies, mostly targeting stroke and musculoskeletal rehabilitation. Accelerometers and IMUs were the most common sensors, typically attached to the trunk, arms, or hands, measuring limb kinematics and posture. Feedback modalities included knowledge of results, performance, or both. Few studies conducted clinical trials, while most evaluated usability. The review highlights emerging embedded sensor systems and the need for more clinical evidence to support effectiveness.ractive wearable systems for upper body rehabilitation.',
    pdf: '/publications/wearable_review.pdf',
    doi: 'https://doi.org/10.1186/s12984-017-0229-y',
    thumbnail: 'thumb3',
    topic: 'Rehabilitation',
    HCI: 'Wearable',
    journal: 'Journal of Neuroengineering and Rehabilitation（J. Neuroeng. Rehabil）',
    honorableMention: false,
    bestPaper: false
  },
  {
    id: 2,
    date: '2016',
    title: 'LivingSurface: Biofeedback Through Shape-Changing Display',
    authors: 'Yu, Bin; Bongers, Nienke; Van Asseldonk, Alissa; Hu, Jun; Funk, Mathias; Feijs, Loe',
    summary: 'ExploresThis paper presents LivingSurface, an interactive shape-changing display that visualizes biofeedback by responding to an individual’s physiological data. The surface has two layers: a laser-cut paper pattern layer and an actuating layer that transforms forces from motors or fans to create motion. Patterns can vibrate, swing, bulge, or rotate to represent bodily processes dynamically. Exhibited at Milan Design Week 2015, visitor feedback was collected and analyzed, highlighting LivingSurface’s potential as a shape-changing interface for biofeedback or ambient information display. biofeedback using a shape-changing surface display for interaction.',
    pdf: '/publications/LivingSurface.pdf',
    doi: 'https://doi.org/10.1145/2839462.283946',
    thumbnail: 'thumb2',
    topic: 'Biofeedback',
    HCI: 'Tangible',
    journal: "Proceedings of the TEI'16: Tenth International Conference on Tangible, Embedded, and Embodied Interaction (TEI)",
    honorableMention: false,
    bestPaper: false
  },
  {
  id: 1,
  date: '2016',
  title: 'Adaptive Biofeedback for Mind-Body Practices',
  authors: 'Yu, Bin',
  summary: 'Presents an adThis research explores an adaptive biofeedback system for mind-body practices, adjusting feedback source, information load, and interface based on users’ physiological states and performance. Biofeedback supports individual regulation of thoughts and physiology. The system is under development, with a future longitudinal evaluation planned to assess its effectiveness in enhancing mind-body interactions.aptive biofeedback system designed to support mind-body practices and relaxation.',
  pdf: '/publications/adaptiveBiofeedback.pdf',
  doi: 'https://doi.org/10.1145/2851581.2859027',
  thumbnail: 'thumb1',
  topic: 'Biofeedback',
  HCI: 'All',
  journal: 'Proceedings of the 2016 CHI Conference Extended Abstracts on Human Factors in Computing Systems',
  honorableMention: false,
  bestPaper: false
}
];


